import React from 'react';

import { Chip, makeStyles, Theme } from '@material-ui/core';
import { Cancel } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  chip: {
    margin: theme.spacing(1),
    height: '32px',
    borderRadius: '16px',
    backgroundColor: '#EAF2FF',
    color: theme.palette.grey[700],
  },
}));

export type KeywordChipProps = {
  label: string;
  handleDelete?: (label: string) => void;
};
export const KeywordChip = (props: KeywordChipProps) => {
  const { label, handleDelete } = props;
  const classes = useStyles();
  const dataFd = label ? label.replace(/ /g, '-') : undefined;
  return handleDelete ? (
    <Chip
      onDelete={() => handleDelete(label)}
      size={'medium'}
      label={label}
      className={classes.chip}
      data-fd={dataFd}
      deleteIcon={<Cancel data-fd={`${dataFd}-delete`} />}
    />
  ) : (
    <Chip data-fd={dataFd} size={'medium'} tabIndex={-1} label={label} className={classes.chip} />
  );
};
